module.exports = __webpack_public_path__ + "img/face44.a0a7d8be.gif";